import React, { Component } from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import { numberWithCommas } from 'Utils/Formatters'
import brandTheme from '../../../../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

export class CodeBlockUnstyled extends Component {
  onDoubleClick = () => {
    const selection = window.getSelection()
    const range = document.createRange()
    range.selectNodeContents(this.codeTextEl_)
    selection.removeAllRanges()
    selection.addRange(range)
  }

  onClick = e => {
    const { freeze, onClick } = this.props
    if (freeze) return
    return onClick(e)
  }

  onMouseDown = addDoubleClickHandler(this.onDoubleClick, this.onClick)

  render = () => {
    const {
      className,
      code,
      quantity,
      onClick,
      style,
      freeze,
      title,
    } = this.props
    return (
      <div
        className={'CodeBlock ' + className}
        style={style}
        onMouseDown={this.onMouseDown}
        onTouchTap={freeze ? null : onClick}
        title={title}
        cypress_id={'flyerCodeBlock'}
      >
        <span
          ref={el => {
            this.codeTextEl_ = el
          }}
        >
          {title} {code}
        </span>
        {quantity && quantity > 1 ? (
          <div
            className={classNames({
              'quantity': true,
              'flag': quantity > 2000 || quantity <= 0,
            })}
            title={`There are ${numberWithCommas(quantity)} items`}
          >
            {numberWithCommas(quantity)}
          </div>
        ) : null}
      </div>
    )
  }
}

export const CodeBlock = styled(CodeBlockUnstyled)`
  background: ${props => {
    if (props.accent) return colors.primary
    return props.theme.colors.regentGray
  }};
  color: ${props => props.theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 2px 2px 0px;
  position: relative;
  font-family: monospace;
  white-space: nowrap;
  /*user-select: none;*/

  .quantity {
    position: absolute;
    bottom: 0;
    right: 0;
    /*background-color: #99b3d4;*/
    font-size: 9px;
    padding: 0 3px;
  }

  .quantity.flag {
    background-color: red;
  }
`

/**
 * Returns an onClick handler that when first quickly in succession will
 * trigger a double click handler
 * @param {Function} onDoubleClickHandler
 * @param {Function|null} onClickHandler Always fired on click
 */
function addDoubleClickHandler(onDoubleClickHandler, onClickHandler) {
  var timeout
  return function(e) {
    if (timeout) {
      onDoubleClickHandler(e)
      clearTimeout(timeout)
      timeout = null
    } else {
      timeout = setTimeout(() => (timeout = null), 1000)
    }
    return onClickHandler ? onClickHandler(e) : null
  }
}
